export interface ResponsiveVisibilityConfig {
  visible?: boolean;
  hidden?: boolean;
  hiddenOnPhone?: boolean;
  hiddenOnTablet?: boolean;
  hiddenOnTabletLandscape?: boolean;
  hiddenOnDesktop?: boolean;
}
